<template>
  <div class="mod-role">
    <el-dialog
      title="流程节点"
      width="60%"
      :close-on-click-modal="false"
      :visible.sync="view.visible">
      <el-table :data="dataList" border class="eltable" v-loading="dataListLoading" size="small" :height=view.conheight.height
                style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50">
        </el-table-column>
        <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
        </el-table-column>
        <el-table-column prop="name" header-align="left" align="left" width="120" label="节点名称">
        </el-table-column>
        <el-table-column prop="nodeType" header-align="left" align="left" width="120" label="节点类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.assignee == '${INITIATOR}'" size="small" type="danger">不可配置</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="nodeDesc" header-align="left" align="left" width="220" label="描述">
          <template slot-scope="scope">
            <p v-if="scope.row.assignee == '${INITIATOR}'">该节点已分配给供应商，无需配置</p>
          </template>
        </el-table-column>
        <el-table-column header-align="left" align="left" min-width="50" label="操作">
          <template slot-scope="scope" v-if="scope.row.assignee != '${INITIATOR}'">
            <el-button type="text" size="small"
                      @click="updateNodesHandle(scope.row.processDefKey, scope.row.name)" icon="el-icon-edit">
              配置
            </el-button>
            <el-button type="text" size="small"
                      @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="view.visible = false">关闭
        </el-button>
      </span>
      <!-- 弹窗, 新增 / 修改 -->
    </el-dialog>
    <assign-position-info v-if="assignPositionVisible" ref="assignPositionInfo"
                          @refreshDataList="getDataList"></assign-position-info>
  </div>
</template>

<script>
  import {fetchTaskNodesByDefId} from '@/controller/workflow'
  import AssignPositionInfo from './assign-position-info'

  export default {
    data () {
      return {
        dataList: [],
        dataListLoading: false,
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 310 + 'px',
            'overflow-y': 'auto'
          }
        },
        viewData: {
        },
        dataForm: {
          id: 0,
          key: ''
        },
        assignPositionVisible: false
      }
    },
    components: {
      AssignPositionInfo
    },
    methods: {
      init (id, key) {
        this.dataForm.id = id || 0
        this.dataForm.key = key || ''
        this.view.visible = true
        this.dataListLoading = true
        this.$nextTick(() => {
          this.getDataList(id);
        })
      },
      getDataList() {
        fetchTaskNodesByDefId(
                {defId: this.dataForm.id}
        ).then(data => {
            if (data && data.code === '00') {
                this.dataList = data.body
            } else {
                this.dataList = []
                this.totalPage = 0
            }
            this.dataListLoading = false
        })
      },
      // 格式化状态 0：冻结 1：启用
      formatStatus (row) {
          return row.itemStatus ? '启用' : '冻结'
      },
      // 新增 / 修改
      updateNodesHandle(key, name) {
          this.assignPositionVisible = true
          this.$nextTick(() => {
              this.$refs.assignPositionInfo.init(key, name)
          })
      },
      // 删除
      deleteHandle() {
      }
    }
  }
</script>
